import { ErrorMessage, Field, Form, Formik } from 'formik';
import React from 'react';
import SpinnerComponent from '../components/SpinnerComponent';
import * as Yup from 'yup';
import { WorkTask } from '../models/worktask';
import { WorkTaskService } from '../services/worktask.service';
import { UploadService } from '../services/upload.service';

interface IState {
    task: WorkTask;
    isLoading: boolean;
    isUploading: boolean;
    isEdit: boolean;
}

export class WorkTaskEditPage extends React.Component<any, IState> {

    constructor(props: any) {
        super(props);

        this.state = {
            task: new WorkTask(),     
            isLoading: false,
            isUploading: false,
            isEdit: false
          };
    }

    componentDidMount() {
        let id = this.props.match.params.id ? this.props.match.params.id : 0;        

        if (id !== 0) {
          this.setState({ isLoading: true });

          WorkTaskService.getById(id)
            .then(
              response => {
                this.setState({
                  task: response,            
                  isLoading: false,
                  isEdit: true
                });
              },
              error => {
                this.setState({ isLoading: false });
              }
            );
        }

        let groupId = this.props.match.params.groupId ? this.props.match.params.groupId : 0;
        if (groupId !== 0) {
            // set work task group ID to data
            let newState = Object.assign({}, this.state.task);
            newState.workTaskGroupId = groupId;
            this.setState({ task: newState });
        }
    }

    uploadFile = (e, setFieldValue) => {
        this.setState({ isUploading: true });

        const file = e.target.files[0] as File;
        const formData = new FormData();
        formData.append("file", file);

        UploadService.uploadFile(formData)
            .then((responseText) => responseText)
            .catch(() => {
                this.setState({ isUploading: false });
            })
            .then((response) => {
                // set uploaded image url to data
                let newState = Object.assign({}, this.state.task);
                newState.taskImage = response as string;
                setFieldValue('taskImage', newState.taskImage);
                this.setState({ task: newState, isUploading: false });
            });
    };

    render() {
        return (
            <div className="col-md-6">
                {this.state.isEdit ? 
                  <h1>Uredi zadatak</h1> : <h1>Kreiraj novi zadatak</h1>}
                {this.state.isLoading ? <SpinnerComponent /> : (
                <Formik
                    initialValues={this.state.task}
                    validationSchema={Yup.object().shape({
                        taskName: Yup.string().required('Naziv zadatka je potreban'),
                        taskImage: Yup.string().required('Slika zadatka je potrebna'),
                        taskOrderKey: Yup.number().required('Unesite broj za poredak'),
                        
                    })}
                    onSubmit={(values, { setStatus, setSubmitting, setError }) => {
                        setStatus();  
                        setError(null);                                     

                        // set uploaded image URL to form input value
                        values.taskImage = this.state.task.taskImage;
                        // set value of group Id
                        values.workTaskGroupId = this.state.task.workTaskGroupId;

                        WorkTaskService.createOrUpdate(values)
                            .then(
                                () => {
                                    setSubmitting(false);
                                    setStatus("Uspješno spremljeno!");
                                },
                                error => {
                                    setSubmitting(false);
                                    setError(error);
                                }
                            );
                    }}
                    render={({ errors, status, touched, isSubmitting, error, setFieldValue, setStatus, setError, setSubmitting }) => (
                        <Form>
                            <div className="form-group">
                                <label htmlFor="taskName">Naziv zadatka</label>
                                <Field name="taskName" type="text" className={'form-control' + (errors.taskName && touched.taskName ? ' is-invalid' : '')} />
                                <ErrorMessage name="taskName" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="taskOrderKey">Poredak zadatka (od najmanjeg broja do najvećeg)</label>
                                <Field name="taskOrderKey" type="number" className={'form-control' + (errors.taskOrderKey && touched.taskOrderKey ? ' is-invalid' : '')} />
                                <ErrorMessage name="taskOrderKey" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <label htmlFor="taskImage">Slika zadatka</label>
                                <Field name="image" type="file" accept="image/png, image/jpeg" onChange={data => this.uploadFile(data, setFieldValue)} />
                            </div>
                            <div className="form-group">
                                <Field name="taskImage" type="text" disabled className={'form-control' + (errors.taskImage && touched.taskImage ? ' is-invalid' : '')} />
                                <ErrorMessage name="taskImage" component="div" className="invalid-feedback" />
                            </div>
                            <div className="form-group">
                                <img src={this.state.task.taskImage} style={{maxHeight:200}} />
                            </div>
                            <div className="form-group">
                                {!this.state.isUploading &&
                                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                                    {this.state.isEdit ? 
                                        <span>Spremi</span> : <span>Kreiraj novi zadatak</span>}
                                    </button>
                                }
                                {this.state.isEdit &&
                                    <button className="btn btn-danger pull-right" disabled={isSubmitting}
                                        onClick={e => {
                                            e.preventDefault();
                                            if (window.confirm("Jeste li sigurni da želite obrisati ovaj zapis?")) {
                                                
                                                setStatus();
                                                setError(null);
                                                WorkTaskService.deleteById(this.state.task.id)
                                                .then(
                                                    () => {
                                                        setSubmitting(false);
                                                        setStatus("Uspješno obrisano!");
                                                    },
                                                    error => {
                                                        setSubmitting(false);
                                                        setError(error);
                                                    }
                                                );
                                            }
                                        }}
                                    >
                                        Izbrisati
                                    </button>
                                }  
                                {isSubmitting || this.state.isUploading &&
                                    <SpinnerComponent/>
                                }                                
                            </div>
                            {error &&
                                <div className={'alert alert-danger'}>{error}</div>
                            }
                            {status &&
                                <div className={'alert alert-success'}>{status}</div>
                            }
                        </Form>
                    )}
                />
                )}
                <button
                    className="button icon-left"
                    onClick={this.props.history.goBack}>
                    Povratak
                </button>
            </div>
        )
    }
}